(function () {
	const nav = document.querySelector('.site-header');
	if (!nav) return;

	class MobileNavigation {
		constructor(params) {
			this.nav = params.nav;
			this.menuItems = this.nav.querySelectorAll('.menu-item');
		}

		init() {
			this.setupMenuItems();
		}

		setupMenuItems() {
			this.menuItems.forEach(item => {
				const link = item.querySelector('a');
				const subMenu = item.querySelector('.sub-menu');
				if (subMenu) {
					this.addClickListeners(link, subMenu);
					this.checkCurrentMenuItems(item, subMenu);
				}
			});
		}

		addClickListeners(link, subMenu) {
			link.addEventListener('click', e => {
				// Check if the clicked element is the svg icon type
				if (e.target.tagName === 'svg' || (e.target.tagName === 'path' && window.innerWidth < 1024)) {
					e.preventDefault();
					this.toggleSubMenu(subMenu);
				}

				// if (window.innerWidth < 1024) {
				// 	e.preventDefault();
				// 	this.toggleSubMenu(subMenu);
				// }
			});
		}

		checkCurrentMenuItems(menuItem, subMenu) {
			if (menuItem.classList.contains('current-menu-item') || menuItem.classList.contains('current-menu-ancestor')) {
				this.toggleSubMenu(subMenu);
			}
		}

		toggleSubMenu(subMenu) {
			if ((window, innerWidth > 1024)) return;
			if (subMenu.style.height) {
				subMenu.style.height = subMenu.scrollHeight - 20 + 'px';
				setTimeout(() => {
					subMenu.style.height = null; // Close the sub-menu
					subMenu.closest('.menu-item').classList.toggle('active');
				}, 50);
			} else {
				subMenu.style.height = subMenu.scrollHeight - 20 + 'px'; // Open the sub-menu
				// Get the animation of the subMenu height then set it to auto after the animation has played
				subMenu.addEventListener(
					'transitionend',
					() => {
						subMenu.style.height = 'auto';
						subMenu.closest('.menu-item').classList.toggle('active');
					},
					{ once: true }
				);
			}
		}
	}

	const mobileNavigation = new MobileNavigation({
		nav: nav,
	}).init();
})();
